import Phaser, {
    Display
} from 'phaser'
import gsap from "gsap";

import QuizQuestions from './QuizQuestions';

//ThisLocation is a string
let thisLocation;
//parent is holds a scene
let parent;
let xmlLoader;
let guide;
let gameScale;
let sounds;
let btnArray;
let padding;
let buttons;
let _this;
let container;
let locations;
let quizQuestions;
let currentButton;
let isQuiz;
let isSetup;

export default class QuizMessaging extends Phaser.Scene {
    constructor() {
        super('wharenuiQuizMessaging')
    }
    init(data) {
        thisLocation = data.thisLocation;
    }

    preload() {}

    create() {
        isSetup = false;
        gameScale = this.registry.get('scaleIt');
        parent = this.scene.get(thisLocation);
        guide = this.scene.get('guide');

        sounds = this.scene.get('sounds');
        parent.events.once('resume', this.setup, this);
        parent.events.on('shutdown', this.stopped, this);
        padding = 10 * gameScale;
        xmlLoader = this.scene.get('xmlLoader');
        buttons = this.add.container(0, 0);
        btnArray = [];
        _this = this;
        this.findLocations();
    }
    stopped() {
        //Other locations are within wharenui location but guide should be cleared too
        let guideImg = guide.getGuide();
        this.clearGuide(guideImg);

        //Location has been stopped so stop this too
        this.registry.remove('keyword');
        currentButton = null;
        isQuiz = false;
        this.scene.stop(thisLocation + "QuizMessaging");
        parent.events.off('resume');
        parent.events.off('shutdown');
    }
    resume() {
        //If in the middle of a quiz bring up the question
        if (isQuiz) {
            quizQuestions.updateQuestion();
        } else {
            //if the user is not engaged in quiz flash the button
            this.maybeLater();
        }
    }
    //create all the buttons for the quiz
    //adding them to the guide as this will be where they are displayed
    setupButtons() {
        let buttons = xmlLoader.getTagFromSection('button');
        let content;
        let btn;
        let rect;

        for (let index = 0; index < buttons.length; index++) {
            btn = guide.add.container(0, 0);
            content = xmlLoader.getLanguage(buttons[index]);
            let text = guide.add.text(0, 0, content, {
                fontFamily: 'Maori, sans-serif',
                fontSize: 19 * gameScale
            });
            text.setColor('0x000000');

            rect = guide.add.rectangle(0, 0, text.width + padding * 4, text.height + padding * 2, 0xffffff);
            rect.alpha = 0.9;
            rect.setStrokeStyle(3 * gameScale, 0x8d8b61);
            rect.setOrigin(0.5);
            rect.name = 'rect';
            text.setOrigin(0.5);
            text.x = btn.x;
            text.y = btn.y;
            text.name = 'text';


            btn.add([rect, text]);
            btn.setSize(rect.width, rect.height);
            btn.setData({
                name: xmlLoader.getAttribute('name', buttons[index]),
                xml: buttons[index],
                width: rect.width,
                height: rect.height,
                english: xmlLoader.getEnglish(buttons[index]),
                maori: xmlLoader.getMaori(buttons[index])
            })

            btn.visible = false;
            btnArray.push(btn);
        }


        //this.registry.events.on('changedata', this.handleLanguage, this);
        this.registry.events.on('changedata-isEnglish', this.handleLanguage, this);
        this.activateButtons();
    }

    //Update the buttons when the language is toggled
    handleLanguage() {

        let txt;
        let rect;
        let btn;

        for (let index = 0; index < btnArray.length; index++) {
            btn = btnArray[index];
            txt = btn.getByName('text');
            rect = btn.getByName('rect');
            if (this.registry.get('isEnglish')) {
                txt.setText(btn.getData('english'));
            } else {
                txt.setText(btn.getData('maori'));
            }


            rect.geom.setSize(txt.width + padding * 4, rect.height);
            rect.setSize(txt.width + padding * 4, rect.height).updateDisplayOrigin().updateData();

            rect.setOrigin(0.5);

            btn.setData({
                width: rect.width,
                height: rect.height
            })

            //Keep the button from going off screen
            let btnX = this.game.canvas.width - rect.width / 2 - padding;
            if (btn.x > btnX) btn.x = btnX;
        }

        //also update the global keyword if there is one
        if (this.registry.values.keyword) {
            let getLang = xmlLoader.getLanguageTag();
            let keyword = xmlLoader.getTag('keyword', getLang)[0].innerHTML.trim();
            let location = this.registry.values.keyword[0];
            this.registry.set('keyword', [location, keyword]);
        }

    }

    activateButtons() {
        let thisOne;
        let btn;
        for (let index = 0; index < btnArray.length; index++) {
            btn = btnArray[index];

            thisOne = btn.getData('name');
            btn.setInteractive({
                useHandCursor: true
            });
            // @ts-ignore
            btn.on('pointerdown', sounds.playClick);
            btn.on('pointerover', this.onOffBtn);
            btn.on('pointerout', this.onOffBtn);

            switch (thisOne) {
                case 'yes':
                case 'tryAgain':
                    btn.on('pointerup', this.startQuiz);
                    break;
                case 'no':
                    btn.on('pointerup', this.maybeLater, this);
                    break;

            }
        }
    }

    startQuiz() {

        isQuiz = true;
        //remove the bubble asking for a quiz
        guide.animateBubbleOut();

        //Remove the button user just clicked on
        gsap.to(this, {
            alpha: 0,
            duration: 0.2,
            scale: 0,
            ease: 'back'
        })

        //check if the quizquestion scene has been started
        quizQuestions = _this.scene.get(thisLocation + 'QuizQuestions');

        if (quizQuestions) {
            _this.scene.launch(thisLocation + 'QuizQuestions', {
                thisLocation: thisLocation
            });
            _this.scene.bringToTop(thisLocation + 'QuizMessaging');
        } else {
            _this.scene.add(thisLocation + 'QuizQuestions', QuizQuestions, true, {
                thisLocation: thisLocation
            });

            quizQuestions = _this.scene.get(thisLocation + 'QuizQuestions');
        }
    }
    finishedQuiz(score, total) {
        xmlLoader.setSection('messages');
        let per = score / total;
        if (per > 0.55) {
            xmlLoader.setSpeech('wellDone');
        } else {
            xmlLoader.setSpeech('goodTry');
        }

        let txt = "<span class='speechExtra'><span class='bigger'>" + score + "/" + total + "</span><br />" + xmlLoader.getLanguage() + "</span>";
        xmlLoader.setSpeech('tryAgain');
        txt = txt + "<br /><br />" + xmlLoader.getLanguage();

        guide.speechBubble({
            text: txt,
            width: 375,
            objs: [btnArray[2]],
            callback: this.maybeLater,
            context: this
        });
        currentButton = btnArray[2];
        currentButton.alpha = 1;

        this.highlightPanel("");

    }
    wrongAnswer(qText) {

        xmlLoader.setSection('messages');
        xmlLoader.setSpeech('wrong');

        let scene = this.scene.get(thisLocation + 'QuizQuestions');

        let txt = "<span class='speechExtra'>" + xmlLoader.getLanguage() + '</span><br /><br />' + qText;

        guide.speechBubble({
            text: txt,
            callback: scene.updateQuestion,
            context: scene
        });

    }

    //User has opted not to do the quiz right now 
    maybeLater() {
        //The guide could call this too early before the user has been asked
        if (!isSetup) return;
        //The quiz is not ongoing
        isQuiz = false;
        //Get the button to keep in the corner
        //start with the yes button [0]
        if (!currentButton) currentButton = btnArray[0];

        //move it to the bottom right corner
        let btnX = this.game.canvas.width - currentButton.getData('width') / 2 - padding;
        let btnY = this.game.canvas.height - currentButton.getData('height') / 2 - padding;

        //if the button is already in the right position pop it
        if (currentButton.x == btnX) {
            gsap.from(currentButton, {
                duration: 0.5,
                scale: 1.1,
                ease: 'back.in'
            })
        } else {
            //otherwise move it into position starting with spot in speechbubble
            //add it from guide to quiz scene
            let sc = guide.getSpeechContainer();
            buttons.add(currentButton);
            currentButton.x += sc.x;
            currentButton.y += sc.y;
            //Remove guide speech bubble
            guide.animateBubbleOut();

            //move it's position
            gsap.to(currentButton, {
                duration: 0.25,
                x: btnX,
                y: btnY
            })
        }

        this.scene.bringToTop('guide');
        this.scene.bringToTop('toolTips');
    }
    onOffBtn() {

        if (this.scale == 1) {
            this.setScale(1.1);
        } else {
            this.setScale(1);
        }
    }

    getIsSetup() {
        return (isSetup);
    }
    //Quiz is only started after user has had chance to explore an overlay (thus pausing the main location)
    setup() {
        //user hasn't started the quiz yet
        isQuiz = false;
        //Listen for the user moving back and forth between overlays and wharenui
        parent.events.on('resume', this.resume, this);
        //Find the possible places user can click here

        //Set the xml to the right section for the quiz
        xmlLoader.setSection('messages');
        xmlLoader.setSpeech('ask');
        //Setup the buttons and store them for future use
        this.setupButtons();
        //Get that guide talking
        guide.speechBubble({
            xmlLoader: xmlLoader,
            objs: [btnArray[0], btnArray[1]],
            isButtons: true
        });
        //Quiz has now been setup
        isSetup = true;
    }

    findLocations() {
        container = parent.getContainer();
        locations = [];
        let guideImg = guide.getGuide();
        guideImg.setData('location', 'guide');

        container.iterate((child) => {
            if (child.data.values.location) locations.push(child);
        });

        locations.push(guideImg);

    }

    //Highlight where to find the answer
    highlightPanel(val) {
        //Highlight the keywords in the panel as well
        if (val == "") {
            this.registry.remove('keyword');
        } else {
            let getLang = xmlLoader.getLanguageTag();
            let keyword = xmlLoader.getTag('keyword', getLang)[0].innerHTML.trim();

            this.registry.set('keyword', [val, keyword]);
        }
        //cycle through the locations to see which one it is
        Phaser.Utils.Array.Each(locations, (obj) => {
            if (obj.data.values.location == val) {
                //most locations are images but one is a container
                try {
                    obj.setTint(0xffcc00);
                } catch {
                    obj.iterate((item) => {
                        item.setTint(0xffcc00);
                    }, obj);
                }

            } else {
                try {
                    obj.clearTint();
                } catch {
                    this.clearGuide(obj);
                }
            }

        }, this)

    }

    clearGuide(obj) {
        obj.iterate((item) => {
            item.clearTint();

        }, this);
    }


}